import React, { useState } from 'react';
import styled from 'styled-components';
import { TablePagination } from '@mui/material';
import StateChip from './StateChip';
import NoResultsFound from '../../../components/common/NoResultsFound';
import SkeletonTable from './SkeletonTable';

export default function GenericTable({
    columns = [],
    rows = [],
    footer = true,
    pageSize = 10,
    loading = false,
    handleOpenModal,
    handleCancelRow,
}) {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(pageSize);

    const handleChangePage = (_, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const paginatedRows =
        rowsPerPage > 0
            ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : rows;

    if (loading) {
        return <SkeletonTable />;
    }
    return (
        <div>
            {paginatedRows.length > 0 ? (
                <>
                    <Table>
                        <thead>
                            <tr>
                                {columns.map((col) => (
                                    <Th key={col.accessor}>{col.label}</Th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedRows.map((row, rowIndex) => (
                                <Tr
                                    key={rowIndex}
                                    onClick={() => handleOpenModal?.(row)}
                                >
                                    {columns.map((col) => (
                                        <Td key={col.accessor || col.label}>
                                            {col.accessor === 'cancel' &&
                                            col.isAction ? (
                                                row.state === 'draft' ? (
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleCancelRow(
                                                                row
                                                            );
                                                        }}
                                                        style={{
                                                            padding: '1rem',
                                                            borderRadius:
                                                                '100%',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        X
                                                    </button>
                                                ) : (
                                                    <span
                                                        style={{
                                                            color: '#aaa',
                                                        }}
                                                    >
                                                        -
                                                    </span>
                                                )
                                            ) : col.accessor === 'state' ? (
                                                <StateChip
                                                    value={row[col.accessor]}
                                                />
                                            ) : col.accessor === 'amount' ? (
                                                <span>
                                                    {row.currency} {row.amount}
                                                </span>
                                            ) : (
                                                (row[col.accessor] ?? '-')
                                            )}
                                        </Td>
                                    ))}
                                </Tr>
                            ))}
                        </tbody>
                    </Table>

                    {footer && (
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 100]}
                            component="div"
                            count={rows.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            labelRowsPerPage="Filas por página"
                        />
                    )}
                </>
            ) : (
                <NoResultsFound message="¡Ups! Actualmente no se encontraron órdenes de servicio." />
            )}
        </div>
    );
}

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 1rem;
`;

const Th = styled.th`
    padding: 10px;
    text-align: left;
    background-color: #f1f1f1;
    color: #b31d15;
    border-bottom: 1px solid #ccc;
    font-size: 0.8rem;
    span {
        display: flex;
        flex-direction: column;
        svg {
            justify-content: start;
        }
    }
`;

const Td = styled.td`
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid #eee;
    font-size: 0.8rem;
`;

const Tr = styled.tr`
    cursor: pointer;
    &:nth-child(even) {
        background-color: #f9f9f9;
    }
`;
